
export const PAGE_ROUTES = {
  HOME: "/",
  MN400: "/mn400",
  MN500: "/mn500",
  ACCESSORIES: "/accessories",
  IDEAL_FOR: "/who-its-for",
  OUR_STORY: "/our-story",
  CONTACT: "/contact",
  CART: "/cart",
  CHECKOUT: "/checkout",
  ORDER_RESULT: "/order/:result",
  TERMS: "/terms-and-conditions",
  PRIVACY: "/privacy-policy",
  SHIPPING: "/shipping-policy",
  REFUND: "/refund-policy",
};

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const CONTACT_DETAILS = {
  EMAIL: "info@minotaur-gear.co.za",
  PHONE: "072 856 3713",
  PHONE_INTL: "+27 72 856 3713",
  WHATSAPP: "https://wa.me/27728563713",
  INSTAGRAM: "https://www.instagram.com/minotaurgear",
  INSTAGRAM_HANDLE: "@minotaurgear",
  FACEBOOK: "https://facebook.com/profile.php?id=61577229481707",
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
